<template>
  <main>
    <div class="container">

      <section class="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

              <div class="d-flex justify-content-center py-4">
                <router-link to="/" class="logo d-flex align-items-center w-auto">
                  <img src="assets/img/logo.png" alt="">
                  <span class="d-none d-lg-block">FinPlan</span>
                </router-link>
              </div>

              <div class="card mb-3">

                <div class="card-body">

                  <div class="pt-4 pb-2">
                    <h5 class="card-title text-center pb-0 fs-4">Войти</h5>
                    <p class="text-center small">Введите почту и пароль</p>
                  </div>

                  <form class="row g-3">

                    <div class="col-12">
                      <label for="email" class="form-label">Email</label>
                      <div class="input-group has-validation">
                        <input type="text" name="username" v-model="email" class="form-control" id="email" required>
                      </div>
                    </div>

                    <div class="col-12">
                      <label for="password" class="form-label">Пароль</label>
                      <input v-model="password" type="password" name="password" class="form-control" id="password" required>
                    </div>

                    <div v-if="error" class="invalid-feedback" style="display: block" v-html="error"></div>
                    <div class="col-12">
                      <button class="btn btn-primary w-100" :disabled="loading" @click="onLogin">
                        <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Войти
                      </button>
                    </div>
                    <div class="col-12">
                      <GoogleAuthBtn @login="loginWithGoogle" />
                    </div>
                    <div class="col-12">
                      <p class="small mb-0">Нет аккаунта? <router-link to="/register">Регистрация</router-link></p>
                    </div>
                    <div class="col-12">
                      <p class="small mb-0">Хотите подтвердить email? <router-link to="/confirm">Подтвердить</router-link></p>
                    </div>
                    <div class="col-12">
                      <p class="small mb-0">Забыли пароль? <router-link to="/recover">Восстановить</router-link></p>
                    </div>
                  </form>

                </div>
              </div>

            </div>
          </div>
        </div>

      </section>

    </div>
  </main>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { usePersonal } from '@/features/personal/composables/usePersonal';
import GoogleAuthBtn from "@/features/personal/components/GoogleAuthBtn.vue";

const router = useRouter();
const route = useRoute();
const { login } = usePersonal();

const email = ref('');
const password = ref('');
const error = ref('');
const loading = ref(false);

function loginWithGoogle() {
  window.location.href = '/oauth2/authorization/google'
}

async function onLogin() {
  error.value = '';
  loading.value = true;
  try {
    await login(email.value, password.value);
    const redirect = route.query.redirect || '/dashboard';
    await router.push(redirect);
  } catch (e) {
    switch (e.code) {
      case 'email_not_confirmed':
        error.value = 'Этот email не подтвержден, можете его <a href="/confirm?email=' + email.value + '">подтвердить</a>';
        break;
      default:
        error.value = 'Ошибка входа. Проверьте email/пароль';
        break;
    }
  } finally {
    loading.value = false;
  }
}
</script>


